"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = WhitePanelLayout;

var _react = _interopRequireDefault(require("react"));

require("./whitePanel.scss");

var _reactRouterDom = require("react-router-dom");

WhitePanelLayout.defaultProps = {
  className: '',
  id: ''
};

function WhitePanelLayout(props) {
  var _props$className = props.className,
      className = _props$className === void 0 ? '' : _props$className,
      children = props.children,
      title = props.title,
      seeAllLink = props.seeAllLink,
      id = props.id;
  return _react["default"].createElement("div", {
    className: "".concat(className, " white-panel"),
    id: id
  }, title && _react["default"].createElement("h2", null, title, " ", seeAllLink && _react["default"].createElement("span", {
    className: "alink"
  }, _react["default"].createElement(_reactRouterDom.Link, {
    to: seeAllLink
  }, "See All"))), children);
}